import logo from './logo.svg';
import './App.css';
import React,{useRef,useState,useEffect,useCallback,useMemo} from 'react';
import {createTheme,ThemeProvider} from "@mui/material/styles"
import CssBaseline from '@mui/material/CssBaseline'
import darkModeTheme from './DarkModeTheme';
import dayjs from 'dayjs'
import{grey} from '@mui/material/colors';
import {Autocomplete,Skeleton,MobileStepper,Modal,Pagination,Tabs,Tab,styled,SpeedDialIcon,SpeedDial,SpeedDialAction,Select,MenuItem,Container,Button,CircularProgress,Fade,Divider,Box,List,ListItem,ListItemButton,ListItemText,ListItemIcon,Grid,SwipeableDrawer,Typography,TextField,Paper,AppBar,Toolbar,IconButton,InputAdornment} from '@mui/material';
import {Share,KeyboardArrowLeft,KeyboardArrowRight,FilterAlt,QuestionMarkOutlined,SchoolOutlined,MenuOutlined,SearchOutlined,InfoOutlined} from '@mui/icons-material'
import {createBrowserRouter,RouterProvider,createMemoryRouter} from 'react-router-dom';
import {Gauge, gaugeClasses,GaugeContainer,GaugeValueArc,GaugeReferenceArc} from '@mui/x-charts/Gauge'
import {useNavigate,createSearchParams,useSearchParams} from 'react-router-dom'
import {Global} from '@emotion/react';
import {DatePicker,LocalizationProvider} from '@mui/x-date-pickers'
import Carousel from 'react-material-ui-carousel';
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { useForm, ValidationError } from '@formspree/react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {autoPlay} from 'react-swipeable-views-utils'
import SwipeableViews from 'react-swipeable-views'
import {useTheme} from '@mui/material/styles';

import {
  Chart as ChartJS,
  CategoryScale,
  ArcElement,
  LinearScale,
  PointElement,
  BarElement,
  PieController,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import {Line,Bar,Pie,getDatasetAtEvent,getElementAtEvent,getElementsAtEvent} from 'react-chartjs-2'


import {db,getMacroReports,getFullReport,getSingleMacroReport,getMacroReportNames} from './firebase';

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
)


const AutoPlaySwipeableViews = SwipeableViews




function ReviewModal({ reviews, isOpen,title, handleClose,report }) {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="review-modal-title"
      aria-describedby="review-modal-description"
    >
      <Container sx={{ width: '80%', mt: 10, bgcolor: 'background.paper', p: 2, borderRadius: 2 }}>
        <Typography id="review-modal-title" variant="h6" component="h2">
          {title}
        </Typography>
        <Tabs value={selectedTab} onChange={handleChangeTab} aria-label="review tabs">
          <Tab label="Positive" />
          <Tab label="Negative" />
          <Tab label="Neutral" />
        </Tabs>
        <TabPanel value={selectedTab} index={0}>
          {reviews?.Positive.map((review, index) => (
            <Typography key={index} sx={{ mt: 2, mb: 2 }}>
              {report?.individual[review]?.content} on {report?.individual[review]?.date||"No Positive Reviews Found"}
            </Typography>
          ))}
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          {reviews?.Negative.map((review, index) => (
            <Typography key={index} sx={{ mt: 2, mb: 2 }}>
              {report?.individual[review]?.content} on {report?.individual[review]?.date||"No Negative Reviews Found"}
            </Typography>
          ))}
        </TabPanel>
        <TabPanel value={selectedTab} index={2}>
          {reviews?.Neutral.map((review, index) => (
            <Typography key={index} sx={{ mt: 2, mb: 2 }}>
              {report?.individual[review]?.content} on {report?.individual[review]?.date||"No Neutral Reviews Found"}
            </Typography>
          ))}
        </TabPanel>
      </Container>
    </Modal>
  );
}




function MarkdownComponent(props)
{
  const markdown = props.markdown
  return(
    <Markdown components={{table:"h4"}} remarkPlugins={[remarkGfm]}>{markdown}</Markdown>
  )
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3,maxHeight:350,overflow:"auto" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}


const Puller = styled('div')(({ theme }) => ({
  width: 30,
  height: 6,
  backgroundColor: theme.palette.mode === 'light' ? grey[300] : grey[900],
  borderRadius: 3,
  position: 'absolute',
  top: 8,
  left: 'calc(50% - 15px)',
}));

const router = createBrowserRouter([
  {
    path:"/",
    element: <Main/>,
  },
  {
    path:"institution",
    element:<Institution/>
  },
  {
    path:"institutions",
    element:<AllInstitutions/>
  },
  {
    path:"inquiry",
    element:<InquiryPage/>
  }
])


export const themeOptions = {
  palette: {
    mode:'dark',
    primary: {
      main: '#3f51b5',
    },
    secondary: {
      main: '#f50057',
    },
  },
};



function App() {

  return (
    <RouterProvider router={router}/>
  )

}


const InquiryForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
  });

  const [state,handleSubmit] = useForm("xvoeddrp")

  if(state.succeeded){
    return <p>Thanks for submitting! Isaiah will be in touch with you shortly.</p>
  }


  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" align="center" gutterBottom>
        Inquiry Form
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="First Name"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <ValidationError prefix="firstName" field="firstName" errors={state.errors}/>
        <TextField
          label="Last Name"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <ValidationError prefix="lastName" field="lastName" errors={state.errors}/>
        <TextField
          label="Contact Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <ValidationError prefix="email" field="email" errors={state.errors}/>
        <TextField
          label="Inquiry of Interest"
          name="message"
          value={formData.message}
          onChange={handleChange}
          fullWidth
          multiline
          rows={4}
          margin="normal"
          required
        />
        <ValidationError prefix="message" field="message" errors={state.errors}/>
        <Button disabled={state.submitting} type="submit" variant="contained" color="primary">
          Submit
        </Button>
      </form>
    </Container>
  );
};

function TopBar()
{
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const handleOpen = () =>
  {
    setOpen(true)
  };
  const handleClose = () =>
  {
    setOpen(false);
  }
  const [institutionNames,setInstitutionNames] = useState([])
  useEffect(()=>
  {
    getMacroReportNames(db).then((res)=>
    {
      setInstitutionNames(res);
    })
  },[])
  const handleSearchSelection = (event,newInputValue)=>
  {
    console.log(newInputValue)
    const query = newInputValue.toLowerCase().replace("/\s+/g","_"); 
    navigate({pathname:"/institution",search:`?q=${query}`})
    
  }
  return(
    <AppBar position = "sticky">
    <SwipeableDrawer anchor="left"  open={open} onOpen={handleOpen} onClose={handleClose}>
      <Box sx={{width:250}}>
        <Typography p={2} variant="h5">Artificial Neural Understanding for Better Institutional Success</Typography>
        <Typography p={3} variant="h6">by Isaiah Freeman (KingTechnician)</Typography>
        <Divider/>
        <List>
          <ListItem key="about" disablePadding>
            <ListItemButton onClick={()=>{navigate("/")}}>
              <ListItemIcon>
                <InfoOutlined/>
              </ListItemIcon>
              <ListItemText>
                About
              </ListItemText>
            </ListItemButton>
          </ListItem>
          <ListItem key="institutions" disablePadding>
            <ListItemButton onClick={()=>{navigate("/institutions")}}>
              <ListItemIcon>
                <SchoolOutlined/>
              </ListItemIcon>
              <ListItemText>
                Find Institutions
              </ListItemText>
            </ListItemButton>
          </ListItem>
          <ListItem key="inquiry" disablePadding>
            <ListItemButton onClick={()=>{navigate("/inquiry")}}>
              <ListItemIcon>
                <QuestionMarkOutlined/>
              </ListItemIcon>
              <ListItemText>
                Business Inquiry?
              </ListItemText>
            </ListItemButton>
            
          </ListItem>
        </List>
      </Box>
    </SwipeableDrawer>
    <Toolbar>
      <IconButton onClick={handleOpen} size="large" edge="start" color="inherit" aria-label="open drawer" sx={{mr:2}}>
        <MenuOutlined/>
      </IconButton>
      <Typography variant="h6" noWrap component="div" sx={{flexGrow:1, display:{xs:'none',sm:'block'}}}>
        The ANUBIS Project
      </Typography>
      <Autocomplete sx={{width:250}} onChange={handleSearchSelection}  variant="standard" label="Search here..."
      options={institutionNames} renderInput={(params)=><TextField {...params} label="Search here..."/>}/>
    </Toolbar>
  </AppBar>
  )
}



function Main() {
  const navigate = useNavigate();
  const trueTheme = createTheme(darkModeTheme);
  const [institutionNames,setInstitutionNames] = useState([])
  useEffect(()=>
  {
    getMacroReportNames(db).then((res)=>
    {
      setInstitutionNames(res);
    })
  },[])
  const handleSearchSelection = (event,newInputValue)=>
  {
    console.log(newInputValue)
    const query = newInputValue.toLowerCase().replace("/\s+/g","_"); 
    navigate({pathname:"/institution",search:`?q=${query}`})
    
  }

  return (
    <ThemeProvider theme={trueTheme}>
      <CssBaseline />
      <TopBar />
      <Box sx={{ textAlign: 'center' }}>
      <Fade in timeout={1000}>
          <Typography variant="h4" gutterBottom>
            Introducing ANUBIS: Artificial Neural Understanding for Institutional Success
          </Typography>
        </Fade>
        <Box sx={{ marginTop: '2rem' }}>
          <Fade in timeout={3500}>
            <Box sx={{ backgroundColor: 'transparent', padding: '1rem' }}>
              <Typography variant="h5" gutterBottom>
                About Me and the Project
              </Typography>
              <Typography variant="body1" gutterBottom>
                My name is Isaiah Freeman, a freelance developer completing my Bachelor's of Computer Science at Virginia State University.
              </Typography>
              <Typography variant="body1" gutterBottom>
                Conversations with administrators both at VSU and many other institutions have revealed that they have had challenges with a very important institutional feature: feedback.
              </Typography>
              <Typography variant="body1" gutterBottom>
                So I've developed a methodology and API for a tool that uses natural language processing (NLP) techniques to not only automate the feedback process, but allow it to be customizeable to your use case and institution.
              </Typography>
            </Box>
          </Fade>
        </Box>
        <Box sx={{ width:"100%", marginTop: '2rem' }}>
          <Fade in timeout={3500}>
            <Box sx={{ backgroundColor: '#1c2331', padding: '3rem' }}>
              <Typography variant="h5" gutterBottom>
                Streamlined Feedback Analysis
              </Typography>
              <Typography variant="body1" gutterBottom>
                Let automation do the grunt work for you. ANUBIS will generate a portfolio based from your reviews. If they're from different time periods, we'll take that into account too, creating a holistic summary that explains your departmental performance over time.
              </Typography>
            </Box>
          </Fade>
          <Divider />
          <Fade in timeout={4000}>
            <Box sx={{ backgroundColor: '#2d3748', padding: '3rem' }}>
              <Typography variant="h5" gutterBottom>
                Effortless Data Input
              </Typography>
              <Typography variant="body1" gutterBottom>
                ANUBIS will take any categories you might have used and aggregate them for you. Don't have any? No worries! ANUBIS uses named entity recognition to extract organizations, names, and locations.
              </Typography>
            </Box>
          </Fade>
          <Divider/>
          <Fade in timeout={4500}>
            <Box sx={{ backgroundColor: '#4a5568', padding: '3rem' }}>
              <Typography variant="h5" gutterBottom>
                Comprehensive Sentiment Portfolio
              </Typography>
              <Typography variant="body1" gutterBottom>
                Get ready to receive a comprehensive portfolio of sentiments, aggregated individually, and by topics, each with examples – all at your fingertips. ANUBIS delivers a macro and micro view of your institution's feedback, empowering you to make data-driven decisions and drive positive change.
              </Typography>
            </Box>
          </Fade>
          <Divider/>
          <Fade in timeout={5000}>
            <Box sx={{ backgroundColor: '#718096', padding: '3rem' }}>
              <Typography variant="h5" gutterBottom>
                Malleable To Your Use Case
              </Typography>
              <Typography variant="body1" gutterBottom>
                I've gone the extra mile by allowing ANUBIS to use any sentiment analysis model, named entity recognition model, and any LLM for topic selection, from the HuggingFace Hub. Are you a researcher that might want to evaluate performance of models working in tandem? Are you a business that wants to leverage this technology from your own internal reviews? ANUBIS can integrate with your preferred soluttions.
              </Typography>
            </Box>
          </Fade>
        </Box>
        <Box sx={{ backgroundColor: 'transparent', padding: '3rem' }}>
              
              <Typography variant="body1" gutterBottom>
                This tool is not quite ready for open use yet. But to get a small idea of what can be extracted, this site has a data explorer using 10,000+ reviews extracted from Gradreports.com encompassing over 200 colleges and universities. Why not take a look?
              </Typography>
            </Box>
        <Box sx={{ marginTop: '2rem' }}>
          <Typography variant="h6" gutterBottom>
            Start Searching Schools
          </Typography>
          <Autocomplete sx={{width:"100%"}} onChange={handleSearchSelection}  variant="standard" label="Search here..."
      options={institutionNames} renderInput={(params)=><TextField {...params} label="Search here..."/>}/>
          <br></br>
          <br></br>
        </Box>
        <Box sx={{ marginTop: '2rem', padding: '1rem', backgroundColor: '#1a202c', color: '#fff' }}>
          <Typography variant="body2" gutterBottom>
            Developed by KingTechnician (Isaiah Freeman) - freelance developer, independent contractor
          </Typography>
          <Typography variant="body2">
            Advised by Dr. Joseph Shelton
          </Typography>
          <Typography variant = "body2">
            Sentiment model for this demo used <a target="_blank" href="https://huggingface.co/lxyuan/distilbert-base-multilingual-cased-sentiments-student"> is here</a>
          </Typography>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

function getColor(value) {
  // Ensure the input value is within the valid range
  value = Math.max(0, Math.min(100, value));

  // Calculate the red and green components based on the value
  const red = Math.round(255 * (1 - value / 100));
  const green = Math.round(255 * (value / 100));

  // Convert the red and green components to hex strings
  const redHex = red.toString(16).padStart(2, '0');
  const greenHex = green.toString(16).padStart(2, '0');

  // Create the hex color string
  const color = `#${redHex}${greenHex}00`;

  return color;
}

const getValueColor = (value) => {
  if (value < 33) {
    return "#f44336"; // Red for "Bad"
  } else if (value < 66) {
    return "#ffc107"; // Yellow for "Average"
  } else {
    return "#4caf50"; // Green for "Good"
  }
};


function InquiryPage()
{
  const trueTheme = createTheme(darkModeTheme)
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    inquiry: '',
  });

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  return(
  <ThemeProvider theme={trueTheme}>
    <CssBaseline/>
    <TopBar/>
    <InquiryForm/>

  </ThemeProvider>
  )
}


function AllInstitutions() {
  const [currentPage,setCurrentPage] = useState(1);
  const resultsPerPage = 5;
  const indexOfLastResult = currentPage*resultsPerPage;
  const indexOfFirstResult = indexOfLastResult-resultsPerPage;
  const trueTheme = createTheme(darkModeTheme);
  const navigate = useNavigate();
  const[filterAscending,setFilterAscending] = useState(false);
  const [filterCategory,setFilterCategory] = useState("Total");
  const [filterModal, setFilterModal] = useState(false);
  const [institutionResults, setInstitutionResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handleFilterOpen = useCallback(() => {
    setFilterModal(true);
  }, []);
  const handlePageChange = (event,value)=>
  {
    setCurrentPage(value);
  }
  const handleFilterClose = useCallback(() => {
    setFilterModal(false);
  }, []);
  const handleFilterChange = useCallback((event)=>{
    setFilterCategory(event.target.value)
  })
  const handleFilterAscending=useCallback((event)=>
  {
    setFilterAscending(!filterAscending)
  })
  const handleQuery = useCallback((event) => {
    setSearchQuery(event.target.value);
  }, []);

  const filteredResults = useMemo(() => {
    const results = searchQuery.trim().length === 0
      ? institutionResults
      : institutionResults.filter(institution => institution.institution.includes(searchQuery));
  
    if (filterCategory && filterAscending !== undefined) {
      return results.sort((a, b) => {
        const valueA = a.sentiment[filterCategory.toLowerCase()];
        const valueB = b.sentiment[filterCategory.toLowerCase()];
        if (filterAscending) {
          return valueA - valueB;  // For ascending order
        } else {
          return valueB - valueA;  // For descending order
        }
      });
    }
  
    return results;
  }, [institutionResults, searchQuery, filterCategory, filterAscending]);
  

  useEffect(() => {
    // Placeholder for the actual data fetching function
    getMacroReports(db).then(res => {
      setInstitutionResults(res);
    });
  }, [db]); // db should be included if it's a prop or context that might change

  return (
    <ThemeProvider theme={trueTheme}>
      <Modal open={filterModal} onClose={handleFilterClose}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', alignItems: "center", backgroundColor: '#1c2331', padding: '1rem', borderRadius: '4px' }}>
          <Typography textAlign="center" variant="h4">Filter Institution Reports</Typography>
          <Typography textAlign="center" variant="h6">Sort by:</Typography>
          <Select onChange={handleFilterChange} fullWidth={true} value={filterCategory} label="Sort By">
            <MenuItem value={"Total"}>Count</MenuItem>
            <MenuItem value={"Positive"}>Positive Sentiment</MenuItem>
            <MenuItem value={"Negative"}>Negative Sentiment</MenuItem>
            <MenuItem value={"Neutral"}>Neutral Sentiment</MenuItem>
          </Select>
          <br></br>
          <br></br>
          <Typography textAlign="center" variant="h6">Ascending or Descending</Typography>
          <Select fullWidth={true} onChange={handleFilterAscending} value={filterAscending} label="Ascending or Descending">
            <MenuItem value={true}>Ascending</MenuItem>
            <MenuItem value={false}>Descending</MenuItem>
          </Select>
          <br></br>
          <br></br>
        </Box>
      </Modal>
      <CssBaseline />
      <TopBar />
      <Fade in timeout={500}>
        <Box sx={{ alignItems: "center", backgroundColor: '#1c2331', padding: '1rem', borderRadius: '4px' }}>
          <Typography textAlign="center" variant="h4">Search Institution Reports Below</Typography>
          <br></br>
          <TextField value={searchQuery} onChange={handleQuery} fullWidth={true} />
          <br></br>
          <br></br>
          <Box textAlign="center"><Button variant="contained">Start Searching</Button></Box>
          <br></br>
          <Box textAlign="center"><Button onClick={handleFilterOpen} variant="contained" color="secondary">Filter Results</Button></Box>
        </Box>
      </Fade>
      <br></br>
      <Typography variant="h4">Search Results ({filteredResults.length})</Typography>
      <br></br>
      
      {filteredResults.slice(indexOfFirstResult,indexOfLastResult).map((institution, i) => (
        <div key={i}>
          <br></br>
          <Box p={3} sx={{ backgroundColor: '#1c2331', padding: '3rem' }}>
            <Typography variant="h5" gutterBottom>
              {institution.institution}
            </Typography>
            <Typography variant="body1" gutterBottom>
              {institution.summary || "Summary not provided"}
            </Typography>
            <MacroReport diversityValue={Math.round(institution.topic_scores.diversity_score * 100) || 0} sentimentValue={institution.sentiment} coherenceValue={Math.round(institution.topic_scores.coherence_score) * 100 || 0} />
            <Typography variant="h5">{institution.sentiment.total} Reviews</Typography>
            <Box textAlign="center"><Button onClick={() => {const query = institution.institution.toLowerCase().replace("/\s+/g","_"); navigate({pathname:"/institution",search:createSearchParams({q:query}).toString()}) }} variant="contained">See Full Portfolio</Button></Box>
          </Box>
          <br></br>
        </div>
      ))}
      
      <footer style={{position:"sticky",bottom:0,padding:"10px 0"}}>
        <Pagination onChange={handlePageChange} color="secondary" count={Math.ceil(institutionResults.length/resultsPerPage)} sx={{display: "flex", justifyContent: "center" }} />
      </footer>
    </ThemeProvider>
  );
}


function SentimentGauge(props)
{
  const title = props.title
  const sentiment = props.sentiment
  const type = props.type
  return(
    <Grid item xs={12}>
          <Grid container spacing={1} alignItems={"center"}>
            <Grid item xs={12}>
              <Gauge value={Math.round(sentiment[type.toLowerCase()]*100)} startAngle={-110} endAngle={110} height={200}
              text={({value,valueMax}) => `${value} / ${valueMax}`}/>
            </Grid>
            <Grid item xs={12}>
              <Typography align="center" variant="h6" gutterBottom>{type} Score</Typography>
            </Grid>
          </Grid>
    </Grid>
  )
}


function MacroReport(props) {
  const [sentimentValue, setSentimentValue] = useState(props.sentimentValue);
  const [diversityValue, setDiversityValue] = useState(props.diversityValue);
  const [coherenceValue, setCoherenceValue] = useState(props.coherenceValue);

  // Update internal state when props change
  useEffect(() => {
    setSentimentValue(props.sentimentValue);
    setDiversityValue(props.diversityValue);
    setCoherenceValue(props.coherenceValue);
  }, [props.sentimentValue, props.diversityValue, props.coherenceValue]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={4}>
        <SentimentGauge title="Positive Score" sentiment={sentimentValue} type="Positive" />
      </Grid>
      <Grid item xs={4}>
        <SentimentGauge title="Neutral Score" sentiment={sentimentValue} type="Neutral"/>
      </Grid>
      <Grid item xs={4}>
        <SentimentGauge title="Negative Score" sentiment={sentimentValue} type="Negative"/>
      </Grid>
    </Grid>
  );
}

const drawerBleeding = 56;

function BertopicItem(props)
{
  const item = props.item
  const name = props.item?.name
  const description = props.item?.description
    return (
      <Box sx={{ backgroundColor: '#1c2331', padding: '3rem' }}>
        <Typography variant="h5" align="center" gutterBottom>
          {name}
        </Typography>
        
        <MarkdownComponent markdown={description}/>
      </Box>
      
    )
}

function findClosestDate(targetDate,dateList)
{
  let closestDate = null;

  const target = new Date(targetDate);

  for(let dateString of dateList)
  {
    let date = new Date(dateString);

    if(date <= target && (!closestDate || date > new Date(closestDate)))
    {
      closestDate = dateString;
    }
  }


  return closestDate;
}

function generateDateList(startDate, endDate, delta) {
  // Parse the start and end date from string to Date object
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Create a list to hold all the dates
  let dateList = [];

  // Loop from start date to end date with the given delta
  for (let dt = new Date(start); dt <= end; ) {
      dateList.push(new Date(dt).toISOString().slice(0,10));  // Add current date to list

      // Increment date by delta
      if (delta.days) {
          dt.setDate(dt.getDate() + delta.days);
      } else if (delta.weeks) {
          dt.setDate(dt.getDate() + (delta.weeks * 7));
      } else if (delta.months) {
          dt.setMonth(dt.getMonth() + delta.months);
      }
  }

  return dateList;
}

function getSentimentsByCategories(fullReport) {
  const categories = fullReport.ranged.categories;
  const labels = new Set();
  const sentimentData = {
    Positive: {},
    Negative: {},
    Neutral: {},
  };
  const categoryCount = {};

  // Collect unique labels, sentiment data, and category count
  for (const date in categories) {
    for (const category in categories[date]) {
      labels.add(category);
      sentimentData.Positive[category] = (sentimentData.Positive[category] || 0) + categories[date][category].positive;
      sentimentData.Negative[category] = (sentimentData.Negative[category] || 0) + categories[date][category].negative;
      sentimentData.Neutral[category] = (sentimentData.Neutral[category] || 0) + categories[date][category].neutral;
      categoryCount[category] = (categoryCount[category] || 0) + 1;
    }
  }

  const labelsList = Array.from(labels);
  const datasets = [
    {
      label: "Positive",
      data: labelsList.map(category => sentimentData.Positive[category] / categoryCount[category]),
      backgroundColor: "green",
    },
    {
      label: "Negative",
      data: labelsList.map(category => sentimentData.Negative[category] / categoryCount[category]),
      backgroundColor: "red",
    },
    {
      label: "Neutral",
      data: labelsList.map(category => sentimentData.Neutral[category] / categoryCount[category]),
      backgroundColor: "grey",
    },
  ];

  return {
    labels: labelsList,
    datasets,
  };
}


// Helper function to determine the sentiment label based on the sentiment values
function getSentimentLabel(sentimentData) {
  const { positive, negative, neutral } = sentimentData;
  if (positive >= negative && positive >= neutral) {
    return 'Positive';
  } else if (negative >= positive && negative >= neutral) {
    return 'Negative';
  } else {
    return 'Neutral';
  }
}

function transformCategoricalToPieCharts(data) {
  const categories = data.ranged.categories;
  const pieChartData = {};
    // Collect sentiment data and IDs for each category
    for (const date in categories) {
      for (const category in categories[date]) {
        if (!pieChartData[category]) {
          pieChartData[category] = {
            Positive: 0,
            Negative: 0,
            Neutral: 0,
            ids: {
              Positive: [],
              Negative: [],
              Neutral: [],
            },
          };
        }
        pieChartData[category].Positive += categories[date][category].positive;
        pieChartData[category].Negative += categories[date][category].negative;
        pieChartData[category].Neutral += categories[date][category].neutral;
        categories[date][category].ids.forEach((id) => {
          const sentiment = getSentimentLabel(categories[date][category]);
          pieChartData[category].ids[sentiment].push(id);
        });
      }
    }
  
    // Create pie chart schema for each category
    const pieChartSchemas = {};
    for (const category in pieChartData) {
      const sentimentData = pieChartData[category];
      const totalSentiment = sentimentData.Positive + sentimentData.Negative + sentimentData.Neutral;
  
      pieChartSchemas[category] = {
        labels: ['Positive', 'Negative', 'Neutral'],
        datasets: [
          {
            label: 'Sentiment',
            data: [
              sentimentData.Positive / totalSentiment,
              sentimentData.Negative / totalSentiment,
              sentimentData.Neutral / totalSentiment,
            ],
            backgroundColor: [
              'rgba(75, 192, 192, 0.2)',
              'rgba(255, 99, 132, 0.2)',
              'rgba(201, 203, 207, 0.2)',
            ],
            borderColor: [
              'rgba(75, 192, 192, 1)',
              'rgba(255, 99, 132, 1)',
              'rgba(201, 203, 207, 1)',
            ],
            borderWidth: 1,
          },
        ],
        ids: sentimentData.ids,
      };
    }
  
    return pieChartSchemas;
}


function getSentimentsByDate(fullReport, earliest, latest, timeAmount, timeUnit) {
  const individualDates = [];
  for (const [key, value] of Object.entries(fullReport.individual)) {
    if (value.date >= earliest && value.date <= latest) {
      individualDates.push(value.date);
    }
  }
  individualDates.sort();

  const timeDelta = { [timeUnit]: timeAmount };
  const dateSlices = generateDateList(earliest, latest, timeDelta);

  const negative = {
    label: "Negative",
    data: [],
    borderColor: "red",
    backgroundColor: "rgba(255, 0, 0, 0.5)"
  };
  const positive = {
    label: "Positive",
    data: [],
    borderColor: "green",
    backgroundColor: "rgba(0, 255, 0, 0.5)"
  };
  const neutral = {
    label: "Neutral",
    data: [],
    borderColor: "grey",
    backgroundColor: "rgba(128, 128, 128, 0.5)"
  };

  const sentimentDictionary = {
    positive: {},
    negative: {},
    neutral: {}
  };
  const sentimentCounts = {};

  for (const [id, entry] of Object.entries(fullReport.individual)) {
    if (entry?.date >= earliest && entry?.date <= latest) {
      const properSlot = findClosestDate(entry?.date, dateSlices);
      sentimentDictionary.positive[properSlot] = sentimentDictionary.positive[properSlot] ?? 0;
      sentimentDictionary.negative[properSlot] = sentimentDictionary.negative[properSlot] ?? 0;
      sentimentDictionary.neutral[properSlot] = sentimentDictionary.neutral[properSlot] ?? 0;
      sentimentCounts[properSlot] = sentimentCounts[properSlot] ?? 0;

      sentimentDictionary.positive[properSlot] =
        ((sentimentDictionary.positive[properSlot] * sentimentCounts[properSlot]) + entry?.sentiment?.positive) /
        (sentimentCounts[properSlot] + 1);
      sentimentDictionary.negative[properSlot] =
        ((sentimentDictionary.negative[properSlot] * sentimentCounts[properSlot]) + entry?.sentiment?.negative) /
        (sentimentCounts[properSlot] + 1);
      sentimentDictionary.neutral[properSlot] =
        ((sentimentDictionary.neutral[properSlot] * sentimentCounts[properSlot]) + entry?.sentiment?.neutral) /
        (sentimentCounts[properSlot] + 1);
      sentimentCounts[properSlot] += 1;
    }
  }

  const filteredDateSlices = [];
  for (const date of dateSlices) {
    const positiveValue = sentimentDictionary.positive[date] ?? 0;
    const negativeValue = sentimentDictionary.negative[date] ?? 0;
    const neutralValue = sentimentDictionary.neutral[date] ?? 0;

    if (positiveValue + negativeValue + neutralValue > 0) {
      filteredDateSlices.push(date);
      positive.data.push(positiveValue);
      negative.data.push(negativeValue);
      neutral.data.push(neutralValue);
    }
  }

  const sentimentData = {
    labels: filteredDateSlices,
    datasets: [positive, negative, neutral]
  };

  return sentimentData;
}





function PieChartCarousel(pieCharts,fullReport) {

  const [continueAutoPlay,setContinueAutoPlay] = useState(false);
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const [activeCategory,setActiveCategory] = useState(Object.keys(pieCharts)[activeStep]);

  const [modalOpen,setModalOpen] = useState(false);

  const handleOpenModal = () =>setModalOpen(true);

  const handleCloseModal = () =>setModalOpen(false);


  const maxSteps = Object.keys(pieCharts).length

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const chartRef = useRef();

  const handlePieChartClick = (event) =>
  {
    handleOpenModal(true)
  }


  return (
    <Box sx={{height:"25%" ,width:"65%" }}>
      <ReviewModal title={Object.keys(pieCharts)[activeStep]} report={fullReport} reviews={pieCharts[Object.keys(pieCharts)[activeStep]]?.ids} isOpen={modalOpen} handleClose={handleCloseModal}/>
      <Paper
        square
        elevation={0}
        sx={{
          alignItems: 'center',
          height: 50,
          pl: 2,
          bgcolor: 'background.default',
        }}
      >
      </Paper>
      <AutoPlaySwipeableViews
        autoPlay = {false}
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
                {Object.entries(pieCharts).map(([category, schema]) => (
          <div key={category}>
            <h3>{category}</h3>
            <Pie data ={schema}/>
            <Button onClick={handlePieChartClick} variant="contained">See Examples of {Object.keys(pieCharts)[activeStep]}</Button>
          </div>
        ))}
      </AutoPlaySwipeableViews>
      <MobileStepper
      variant="progress"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
    </Box>
  );
}


function getDateRange(data) {
  const reviews = data.individual;
  const dates = Object.values(reviews).map(review => review.date);
  
  const earliestDate = new Date(Math.min(...dates.map(date => new Date(date))));
  const latestDate = new Date(Math.max(...dates.map(date => new Date(date))));
  
  return {
    earliestDate: earliestDate.toISOString().split('T')[0],
    latestDate: latestDate.toISOString().split('T')[0]
  };
}


function Institution() {
  const [labels, setLabels] = useState(["January", "February", "March", "April"]);
  const [overTimeData, setOverTimeData] = useState({
    labels,
    datasets: [],
  });
  const lineChartRef = useRef()
  const [overCategoriesData, setOverCategoriesData] = useState({});
  const trueTheme = createTheme(darkModeTheme);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredDateRange, setFilterDateRange] = useState({ earliestDate: "", latestDate: "" });
  const [institutionTitle, setInstitutionTitle] = useState("");
  const [fullReport, setFullReport] = useState({ individual: [] });
  const [macroReport, setMacroReport] = useState([]);
  const [coherenceValue, setCoherenceValue] = useState(30);
  const [sentimentValue, setSentimentValue] = useState(30);
  const [spinnerOpen, setSpinnerOpen] = useState(false);
  const [diversityValue, setDiversityValue] = useState(90);
  const [sentimentColor, setSentimentColor] = useState("");
  const [topicColor, setTopicColor] = useState("");
  const [topicTab, setTopicTab] = useState(0);
  const [currentIncrement, setCurrentIncrement] = useState(1);
  const [increments, setIncrements] = useState(["Days", "Weeks", "Months"]);
  const [incrementIndex, setIncrementIndex] = useState(2);

  const handleEarliestDateChange = (newDate) => {
    setFromDate(newDate.format("YYYY-MM-DD"));
  };

  const handleLatestDateChange = (newDate) => {
    setToDate(newDate.format("YYYY-MM-DD"));
  };

  const handleShareClick = ()=>
  {
    navigator.clipboard.writeText(window.location.href)
    alert("Link saved to clipboard!");
  }

  const handleFilterChange = () => {
    const timeUnit = increments[incrementIndex].toLowerCase();
    setOverTimeData(
      getSentimentsByDate(fullReport, fromDate, toDate, currentIncrement, timeUnit)
    );
  };

  const onLineChartClick = (event) =>
  {
    console.log(getElementAtEvent(lineChartRef.current,event))
    console.log(getDatasetAtEvent(lineChartRef.current,event))
  }

  const handleIncrementChange = (event) => {
    setIncrementIndex(event.target.value);
    handleFilterChange();
  };

  const handleIncrementAmountChange = (event) => {
    setCurrentIncrement(event.target.value);
    handleFilterChange();
  };

  const handleResetFilter = () => {
    setFromDate(filteredDateRange.earliestDate);
    setToDate(filteredDateRange.latestDate);
    setOverTimeData(
      getSentimentsByDate(
        fullReport,
        filteredDateRange.earliestDate,
        filteredDateRange.latestDate,
        3,
        "months"
      )
    );
  };
  const [searchParams,setSearchParams] = useSearchParams();
  const q = searchParams.get("q")

  useEffect(() => {
    const queryInstitution = q.replaceAll(" ", "_");
    getFullReport(db, queryInstitution).then((res) => {
      setFromDate(getDateRange(res).earliestDate);
      setToDate(getDateRange(res).latestDate);
      setOverTimeData(
        getSentimentsByDate(res, getDateRange(res).earliestDate, getDateRange(res).latestDate, currentIncrement,increments[incrementIndex].toLowerCase())
      );
      setFilterDateRange(getDateRange(res));
      setOverCategoriesData(transformCategoricalToPieCharts(res));
      transformCategoricalToPieCharts(res);
      setFullReport(res);
    });

    getSingleMacroReport(db, queryInstitution).then((res) => {
      setInstitutionTitle(res.institution);
      setMacroReport(res);
    });
  }, [q]);

  useEffect(() => {
    handleFilterChange();
  }, [fromDate, toDate]);

  const [bertopicItemsOld, setBertopicItemsOld] = useState([
    {
      name: "Classroom Experiences at Virginia State University",
      description: "Experiences seem to be at a moderate level generally.",
    },
    {
      name: "The Psychology Department Experiences",
      description: "This is where the other Description will be.",
    },
  ]);

  const bertopicItems = useMemo(() => {
    const macro = macroReport.macro_conclusions;

    const conclusions = [];

    if (macro !== undefined && macro !== null) {
      for (const [key, value] of Object.entries(macro)) {
        conclusions.push({ name: key, description: value });
      }
    }

    return conclusions;
  });

  const [lineOptions, setLineOptions] = useState({
    responsive: true,
    scales: {
      x: {
        grid: {
          color: "grey",
        },
      },
      y: {
        grid: {
          color: "grey",
        },
      },
    },
    plugins: {
      legend: {
        position: "top",
      },
    },
    title: {
      display: true,
      text: "Sentiments Over Time",
    },
  });

  return (
    <ThemeProvider theme={trueTheme}>
      <CssBaseline />
      <TopBar />
      <br></br>
      <br></br>
      <Box sx={{ backgroundColor: "transparent", position: "sticky" }}>
        
      </Box>
      <br></br>
      <br></br>
      <IconButton onClick={handleShareClick} sx={{align:"right"}} size="large"><Share fontSize="50px" /></IconButton>
      <br></br>{ institutionTitle?(
      <Typography textAlign="center" variant="h4">
        {institutionTitle}
      </Typography>) : (<Skeleton variant="text" height={80}/>)}
      {macroReport? (<MacroReport
        coherenceValue={macroReport?.topic_scores?.coherence_score}
        diversityValue={diversityValue}
        sentimentValue={macroReport?.sentiment || 0.0}
      />) : (<Skeleton variant="rectangular" height={90}/>)}
      
      <br></br>
      {macroReport ? (<Typography p={4} textAlign="center" variant="body1" gutterBottom>
        {macroReport.summary }
      </Typography>): (<Skeleton variant="rectangular" height={200}/>)}
      <Divider />
      <br></br>
      <Box p={2}>
        <Grid container spacing={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid item xs={6}>
              <Typography textAlign="right" variant="h6">
                From:
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <DatePicker
                onChange={handleEarliestDateChange}
                value={dayjs(fromDate)}
                sx={{ width: "150%" }}
                label="From date"
              />
            </Grid>
            <Grid item xs={6}>
              <Typography textAlign="right" variant="h5">
                To:
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <DatePicker
                onChange={handleLatestDateChange}
                value={dayjs(toDate)}
                sx={{ width: "150%" }}
                label="To date"
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" onClick={handleResetFilter}>
                Reset Filter
              </Button>
            </Grid>
          </LocalizationProvider>
        </Grid>
        <Typography textAlign="center" variant="h4">
          Sentiment Over Time
        </Typography>
        <Line onClick={onLineChartClick} ref={lineChartRef} height={100} width={100} options={lineOptions} data={overTimeData} />
        <Typography textAlign="center" variant="h4">
          Sentiment by Categories
        </Typography>
        {PieChartCarousel(overCategoriesData, fullReport)}
      </Box>
      <Carousel autoPlay={false}>
        {bertopicItems.map((item, i) => (
          <BertopicItem key={i} item={item} />
        ))}
      </Carousel>
      <br></br>
      <br></br>
    </ThemeProvider>
  );
}

export default App;
